import { render, staticRenderFns } from "./ChristmasCountdown.vue?vue&type=template&id=3659e952&scoped=true"
import script from "./ChristmasCountdown.vue?vue&type=script&lang=js"
export * from "./ChristmasCountdown.vue?vue&type=script&lang=js"
import style0 from "./ChristmasCountdown.vue?vue&type=style&index=0&id=3659e952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3659e952",
  null
  
)

export default component.exports